import { NgModule } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { OrganizationRiderStoreModule } from '../../store/organization-rider/organization-rider.module';
import { AddEditRideMetadataDialogModule } from './add-edit-ride-metadata-dialog/add-edit-ride-metadata-dialog.module';
import { AddTransitProgramHolidayScheduleModule } from './add-transit-program-holiday-dialog/add-transit-program-holiday-schedule-dialog.module';
import { AdjustReservationStatusDialogModule } from './adjust-reservation-status-dialog/adjust-reservation-status-dialog.module';
import { AlertDialogModule } from './alert-dialog/alert-dialog.module';
import { AllCustomerServiceNotesDialogModule } from './all-customer-service-notes-dialog/all-customer-service-notes-dialog.module';
import { CancelRandomTestDialogModule } from './cancel-random-test-dialog/cancel-random-test-dialog.module';
import { CancelReservationDialogModule } from './cancel-reservation-dialog/cancel-reservation.module';
import { ConfirmationDialogModule } from './confirmation-dialog/confirmation-dialog.module';
import { CopyHolidayScheduleModule } from './copy-holiday-schedule-dialog/copy-holiday-schedule-dialog.module';
import { CreateRandomSubstanceScreeningDialogModule } from './create-random-substance-screening-dialog/create-random-substance-screening-dialog.module';
import { CreateSubstanceScreeningDialogModule } from './create-substance-screening-dialog/create-substance-screening-dialog.module';
import { CreateTransitProgramDialogModule } from './create-transit-program-driver-dialog/create-transit-program-driver-dialog.module';
import { CreateDispatcherDialogModule } from './create-dispatcher-dialog/create-dispatcher-dialog.module';
import { CreateProviderDriverDialogModule } from './create-provider-driver-dialog/create-provider-driver-dialog.module';
import { DetailsDialogModule } from './details-dialog/details-dialog.module';
import { DriverFareCalculationHistoryDailogModule } from './driver-fare-calulation-history-dialog/driver-fare-calculation-history-dialog.module';
import { DriverJourneyDialogModule } from './driver-journey-dialog/driver-journey-dialog.module';
import { EditOrganizationDialogModule } from './edit-organization-dialog/edit-organization-dialog.module';
import { EditRiderDialogModule } from './edit-rider-dialog/edit-rider-dialog.module';
import { EditRoleDialogModule } from './edit-role-dialog/edit-role-dialog.module';
import { EditUserDialogModule } from './edit-user-dialog/edit-user-dialog.module';
import { ExpressProviderDriverInterestDialogModule } from './express-provider-driver-interest-dialog/express-provider-driver-interest-dialog.module';
import { FareAndRatesDetailsDailogModule } from './fare-and-rates-details-dialog/fare-and-rates-details-dialog.module';
import { FavoriteDriversDialogModule } from './favorite-drivers-dialog/favorite-drivers-dialog.module';
import { FavoriteLocationsDialogModule } from './favorite-locations-dialog/favorite-locations-dialog.module';
import { FeeScheduleChangeRequestDialogModule } from './fee-schedule-change-request-dialog/fee-schedule-change-request-dialog.module';
import { LocationManagerDialogModule } from './location-manager-dialog/location-manager-dialog.module';
import { NewCustomerServiceNoteDialogModule } from './new-customer-service-note-dialog/new-customer-service-note-dialog.module';
import { NewDriverSuspensionsDialogModule } from './new-driver-suspension-dialog/new-driver-suspensions-dialog.module';
import { NewPaymentDialogModule } from './new-payment-dialog/new-payment-dialog.module';
import { OnDemandRideDialogModule } from './on-demand-ride-dialog/on-demand-ride-dialog.module';
import { PromptDialogModule } from './prompt-dialog/prompt-dialog.module';
import { RefundPaymentDialogModule } from './refund-payment-dialog/refund-payment-dialog.module';
import { RejectChangeRequestDialogModule } from './reject-change-request-dialog/reject-change-request-dialog.module';
import { ReportDetailDialogModule } from './report-detail-dialog/report-detail-dialog.module';
import { ReservationAlertsDialogModule } from './reservation-alerts-dialog/reservation-alerts-dialog.module';
import { RiderFareCollectionDialogModule } from './rider-fare-collection-dialog/rider-fare-collection-dialog.module';
import { RiderHasBalanceDialogModule } from './rider-has-balance-dialog/rider-has-balance-dialog.module';
import { SelectDialogModule } from './select-dialog/select-dialog.module';
import { SelectDriverDialogModule } from './select-driver-dialog/select-driver-dialog.module';
import { SelectProviderDialogModule } from './select-provider-dialog/select-provider-dialog.module';
import { TransitProgramOperatingScheduleDialogModule } from './transit-program-operating-schedule-dialog/transit-program-operating-schedule.module';
import { TransitProgramSearchModule } from './transit-program-search-dialog/transit-program-search.module';
import { TripNotesDialogModule } from './trip-notes-dialog/trip-notes-dialog.module';
import { UserDeactivationDialogModule } from './user-deactivation-dialog/user-deactivation-dialog.module';
import { ViewRiderNoteHistoryDialogModule } from './view-rider-note-history-dialog/view-rider-note-history-dialog.module';
import { ResolveRideMonitoringAlertDialogModule } from './resolve-ride-monitoring-alert-dialog/resolve-ride-monitoring-alert-dialog.component.module';
import { ApproveFeeScheduleDialogModule } from './approve-fee-schedule-dialog/approve-fee-schedule-dialog.component.module';

@NgModule({
  imports: [
    ApproveFeeScheduleDialogModule,
    AddEditRideMetadataDialogModule,
    AddTransitProgramHolidayScheduleModule,
    CreateRandomSubstanceScreeningDialogModule,
    AdjustReservationStatusDialogModule,
    CreateSubstanceScreeningDialogModule,
    AlertDialogModule,
    AllCustomerServiceNotesDialogModule,
    CancelReservationDialogModule,
    CancelRandomTestDialogModule,
    ConfirmationDialogModule,
    CopyHolidayScheduleModule,
    CreateTransitProgramDialogModule,
    CreateDispatcherDialogModule,
    CreateProviderDriverDialogModule,
    DetailsDialogModule,
    DriverFareCalculationHistoryDailogModule,
    EditOrganizationDialogModule,
    EditRiderDialogModule,
    EditRoleDialogModule,
    EditUserDialogModule,
    ExpressProviderDriverInterestDialogModule,
    FareAndRatesDetailsDailogModule,
    FavoriteDriversDialogModule,
    FavoriteLocationsDialogModule,
    LocationManagerDialogModule,
    NewCustomerServiceNoteDialogModule,
    NewPaymentDialogModule,
    OrganizationRiderStoreModule,
    PromptDialogModule,
    RefundPaymentDialogModule,
    ReportDetailDialogModule,
    ReservationAlertsDialogModule,
    RiderFareCollectionDialogModule,
    RiderHasBalanceDialogModule,
    SelectDialogModule,
    SelectDriverDialogModule,
    SelectProviderDialogModule,
    TransitProgramOperatingScheduleDialogModule,
    TransitProgramSearchModule,
    TripNotesDialogModule,
    UserDeactivationDialogModule,
    ViewRiderNoteHistoryDialogModule,
    RiderHasBalanceDialogModule,
    RefundPaymentDialogModule,
    NewPaymentDialogModule,
    TripNotesDialogModule,
    FareAndRatesDetailsDailogModule,
    DriverFareCalculationHistoryDailogModule,
    FavoriteDriversDialogModule,
    CopyHolidayScheduleModule,
    AdjustReservationStatusDialogModule,
    RiderFareCollectionDialogModule,
    OnDemandRideDialogModule,
    FeeScheduleChangeRequestDialogModule,
    RejectChangeRequestDialogModule,
    DriverJourneyDialogModule,
    ResolveRideMonitoringAlertDialogModule
  ],
  providers: [
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        autoFocus: false,
        minWidth: '40vw',
        maxHeight: '95vh',
        hasBackdrop: true
      }
    }
  ]
})
export class DialogModule {}
